"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Button_1 = require("@Components/Buttons/Button");
const PointPreloader_1 = __importDefault(require("@Components/Preloaders/PointPreloader"));
const Popup_1 = __importDefault(require("@Components/Popups/Popup"));
const ClaimConfirmationPopup = (props) => {
    const { closeModal, submissionLoading, submitClaim, isInternal } = props;
    return (react_1.default.createElement(Popup_1.default, { onClose: closeModal },
        react_1.default.createElement("div", { className: "modal-content" },
            react_1.default.createElement("h2", null, "Confirm Claim"),
            submissionLoading ? (react_1.default.createElement(PointPreloader_1.default, null)) : (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("p", null,
                    "Click ",
                    react_1.default.createElement("b", null, "Claim"),
                    " below to submit your claim on this work to The MLC. To review or edit any information, click ",
                    react_1.default.createElement("b", null, "Back.")),
                react_1.default.createElement("div", { className: "button-row" },
                    react_1.default.createElement(Button_1.Button, { mainColor: true, type: "secondary", onClick: closeModal }, "Back"),
                    react_1.default.createElement(Button_1.Button, { mainColor: true, type: "primary", disabled: isInternal, onClick: () => submitClaim() }, "Claim")))))));
};
exports.default = ClaimConfirmationPopup;
